import { render, staticRenderFns } from "./product-version-badge.vue?vue&type=template&id=e53a88f8&scoped=true"
import script from "./product-version-badge.vue?vue&type=script&lang=js"
export * from "./product-version-badge.vue?vue&type=script&lang=js"
import style0 from "./product-version-badge.vue?vue&type=style&index=0&id=e53a88f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53a88f8",
  null
  
)

export default component.exports